import backend from "../../../../../server.js";
import { toInt, toNum, cleanUndefined } from "../../../../utils/freebetsCore.js";

const FS = backend.freespin;

const IGP_DEMO_CONFIG = {
    CODE: "JU02", ID: 44, DEMO_GAME: true,
    PLAYERS: [
        { id: "JU02_0411443323207", label: "carlosUSD", currency: "USD" },
        { id: "JU02_3892419797047", label: "casinoUSD", currency: "USD" }
    ],
    CURRENCIES: ["USD", "EUR", "PEN"],
    DEFAULTS: { CURRENCY: "USD" },
    SLOT_GAME: { id: "evo_moreturkeyv10000", name: "More Turkey" },
    LIVE_GAMES: [
        { id: "evo_CrazyCoinFlip001", name: "Crazy Coin Flip" },
        { id: "evo_CrazyTime0000001", name: "Crazy Time" }
    ]
};

async function getIgpBetScales({ clientCode, gameId, currency }) {
    const res = await FS.getBetScalesIgp(clientCode, gameId, currency);
    const betLevels = Array.isArray(res?.data?.bet_levels) ? res.data.bet_levels : [];
    return [...new Set(betLevels.map(Number).filter(v => Number.isFinite(v) && v > 0))].sort((a,b) => a - b);
}

const toISO = (t) => (t ? new Date(t).toISOString() : null);

function mapIgpAddPlayer({ campaignId, players }) {
    return {
        campaignId: String(campaignId),
        playerIds: (players || []).map(p => {
            if (typeof p === "string") return p;
            return String(p.playerId ?? p.id ?? "");
        }).filter(Boolean)
    };
}

function mapIgpRemovePlayer({ campaign, playerId, payload }) {  
    const bonus = payload?.bonusCode ;

    return cleanUndefined({
        operator_reference: bonus
    });
}


/** @type {ProviderAdapter} */
export const IGP_ADAPTER = {
    providerCode: "pgi",
    providerName: "IGP",
    types: { slot: true, live: true },
    maxDays: 14,
    bonusPrefix: "IGP_",
    demo: IGP_DEMO_CONFIG,
    validateClient: FS.validateClientIgp,
    getBetScales: getIgpBetScales,
    savePlayer: (dto) => FS.saveIgp(dto),
    deletePlayer: (dto) => FS.deleteIgp(dto),
    temporalAPI: (params) => FS.payloadTemporal(params),
    mapAddPlayer: mapIgpAddPlayer,
    mapRemovePlayer: mapIgpRemovePlayer,
    idStrategy: "clientcode_username"
};
